import {
  OFFERS_API_SUCCESS,
  OFFERS_API_FAIL,
  ADD_FAVOURITES_API_SUCCESS,
  ADD_FAVOURITES_API_FAIL,
  REMOVE_FAVOURITES_API_SUCCESS,
  REMOVE_FAVOURITES_API_FAIL,
} from 'src/services/app-state/personalizedRecommendation/constants'

export default (state = {}, action = {}) => {
  switch (action.type) {
    case OFFERS_API_SUCCESS:
      return { ...state, ...action.data }
    case OFFERS_API_FAIL:
      return {}
    case ADD_FAVOURITES_API_SUCCESS:
      const {
        payload: {
          favouriteItems: [{ skuId }] = [{}],
        } = {},
      } = action.data
      let updatedItem
      const StateWithFavourites = state.items.map((item) => {
        updatedItem = { ...item }
        if (item.id === skuId) {
          updatedItem.productDetails = { ...item.productDetails, isFavourite: true }
        }
        return updatedItem
      })
      return { ...state, items: [...StateWithFavourites] }
    case REMOVE_FAVOURITES_API_SUCCESS:
      const {
        payload: {
          items,
        } = {},
      } = action.data
      let updatedItemFavourites
      const stateWithoutFavourites = state.items.map((item) => {
        updatedItemFavourites = { ...item }
        if (item.id === items[0]) {
          updatedItemFavourites.productDetails = { ...item.productDetails, isFavourite: false }
        }
        return updatedItemFavourites
      })
      return { ...state, items: [...stateWithoutFavourites] }
    case ADD_FAVOURITES_API_FAIL:
    case REMOVE_FAVOURITES_API_FAIL:
      return { ...state }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/reducer/index.js